import { Heading, Grid, Text } from '@simplywallst/ui-core';

import { getStaticUrl, useCloudflareImage } from '@/hooks/useCloudflareImage';

import { StyledGrid } from './styled';

export const NewPortfolioFeaturesBanner = () => {
  const progressTrackerImg = useCloudflareImage({
    src: getStaticUrl('portfolio/feature-usp/progress-tracker.png'),
    width: 144,
    height: 144,
  });

  const risksImg = useCloudflareImage({
    src: getStaticUrl('portfolio/feature-usp/risk-detection.png'),
    width: 144,
    height: 144,
  });

  const valueImg = useCloudflareImage({
    src: getStaticUrl('portfolio/feature-usp/value-watch.png'),
    width: 144,
    height: 144,
  });

  return (
    <>
      <Heading as="h1" typography="smallStrong" textAlign="center">
        How you can leverage our portfolio features
      </Heading>
      <Grid
        templateColumnsLg="repeat(3, 1fr)"
        justifyContent="center"
        alignItems="start"
        gap="24px"
      >
        <Grid templateColumns="max-content auto" alignItems="start" gap="24px">
          <Grid>
            <img alt="Track portfolio's progress" src={progressTrackerImg} />
          </Grid>
          <StyledGrid gap="12px">
            <Text typography="xSmall" color="chart01">
              Progress tracker
            </Text>
            <Text typography="small">
              Monitor Portfolio Performance Against The Market
            </Text>
          </StyledGrid>
        </Grid>
        <Grid templateColumns="max-content auto" alignItems="start" gap="24px">
          <Grid>
            <img alt="Risks notifications" src={risksImg} />
          </Grid>
          <StyledGrid gap="12px">
            <Text typography="xSmall" color="chart06">
              Drawdown prevention
            </Text>
            <Text typography="small">
              Get Notified of New Fundamental Risks
            </Text>
          </StyledGrid>
        </Grid>
        <Grid templateColumns="max-content auto" alignItems="start" gap="24px">
          <Grid>
            <img alt="Get valuation alerts" src={valueImg} />
          </Grid>
          <StyledGrid gap="12px">
            <Text typography="xSmall" color="good">
              Opportunities to optimise
            </Text>
            <Text typography="small">
              Follow & receive alerts on valuations
            </Text>
          </StyledGrid>
        </Grid>
      </Grid>
    </>
  );
};
